<template>
    <div
        class="kleptos-overflow"
        v-on-click-outside.static="clickOutside">

        <!-- ICONS -->
        <div class="kleptos-icons">
            <slot
                :selectedStore="selectedStore"
                :touchedElements="touchedElements"
                :inactiveElements="inactiveElements">
            </slot>
        </div>

        <!-- SELECTION AREA -->
        <div
            v-show="dragSelecting"
            class="selection-area"
            ref="selectionArea"
            :style="selectionAreaStyle">
        </div>

    </div>
</template>

<script>
    /* TODO LIST ---

        * redone __vue__ click match
        * THEN clickOutside tested no bugs
        * switching views - shows errors
        * reinstate grid
        * context menu for .selection - also for indiv icons
        * rename icons
        * selection of icons from multiple locations
        * icons (folders) can be drop targets
    */
    // https://github.com/Simonwep/selection/blob/master/src/selection.js
    import * as _ from './utils';
    import { mixin as onClickOutside } from 'vue-on-click-outside';

    // Some var shorting for better compression and readability
    const {abs, max, min} = Math;
    const preventDefault = e => e.preventDefault();

    export default {
        name: 'vue-selection',
        mixins: [
            onClickOutside
        ],
        props: {},
        data() {
            return {
                options: {
                    // boundaries: ['.icon-view'],
                    class: 'selection-area',
                    containers: [],
                    disableTouch: false,
                    mode: 'touch',
                    selectedClass: 'selected', // legacy
                    selectables: ['.file-boundary'],
                    // singleClick: true, // legacy
                    // startareas: ['.icon-view'],
                    startThreshold: 10,
                    validateStart: () => true
                },
                areaElement: null,
                boundaries: [],
                changedElements: [],
                inactiveElements: [], // new (click outside)
                lastX: null,
                lastY: null,
                selectionAreaStyle: {},
                selectables: [],
                selectedStore: [],
                singleClick: null,
                targetBoundary: null, // type?
                touchedElements: [],
                firstRun: false,
                testVar: {},
                selectedStoreTest: [],
                dragSelecting: false,
            }
        },
        watch: {
            selectedStore() {
                this.$emit('selected-items', this.selectedStore); // is watcher best?
            }
        },
        created() {
            // this.options = Object.assign(this.defaults, this.settings);
        },
        mounted() {
            this.areaElement = this.$refs.selectionArea;
            this.bindStartEvents('on');
        },
        beforeDestroy() {
            this.destroy();
        },
        methods: {

            //-----------------------------------------------------------------
            // 00. BIND START EVENTS
            //-----------------------------------------------------------------

            bindStartEvents(type) {
                _[type](this.$el, 'mousedown', this.onTapStart);

                if (!this.options.disableTouch) {
                    _[type](this.$el, 'touchstart', this.onTapStart, {
                        passive: false
                    });
                }
            },

            //-----------------------------------------------------------------
            // 01. TAP START - MOUSE DOWN
            //-----------------------------------------------------------------

            onTapStart(evt) {
                const {x, y, target} = _.simplifyEvent(evt);
                const multiSelect = evt.shiftKey || evt.ctrlKey || evt.metaKey; // ctl or ⌘ key down --- DUPLICATION

                // Check mouse middleware
                if (!this.options.validateStart(evt)) {
                    return;
                }

                // Find start-areas and boundaries
                const startAreas = [this.$el]; //_.selectAll(this.options.startareas);
                this.boundaries = [this.$el]; //_.selectAll(this.options.boundaries);

                // Check if area starts in one of the start areas / boundaries
                const evtpath = _.eventPath(evt);
                if (!startAreas.find(el => evtpath.includes(el)) ||
                    !this.boundaries.find(el => evtpath.includes(el))) {
                    return;
                }

                // Save start coordinates
                this.lastX = x;
                this.lastY = y;
                this.singleClick = true; // To detect single-click

                // Resolve selectors
                const containers = _.selectAll(this.options.containers);
                this.selectables = _.selectAll(this.options.selectables);
                containers.forEach(con => this.selectables.push(...con.getElementsByTagName('*')));

                // Save current boundary
                this.targetBoundary = this.boundaries.find(el => _.intersects(el, target)).getBoundingClientRect();
                this.touchedElements = [];
                this.changedElements = {
                    added: [],
                    removed: []
                };

                // Prevent default select event
                _.on(this.$el, 'selectstart', preventDefault);

                 // IF TARGET IS NOT AN ICON - ALLOW DRAG & MULTISELECT
                if (evt.target == this.$el) {

                    if (!multiSelect) this.clearSelection();

                    // allow drag selecting - not on icon itself
                    _.on(this.$el, 'mousemove', this.delayedTapMove); // this.$el
                    _.on(this.$el, 'touchmove', this.delayedTapMove, { // this.$el
                        passive: false
                    });
                }
                //~~~~~~~~~~~~~~~~~~~

                // can MOUSEUP anywhere
                _.on(document, ['mouseup', 'touchcancel', 'touchend'], this.onTapStop); // this.$el

                this.onSingleTap(evt); // OLD

                // evt.preventDefault(); // prevents drag
            },

            //-----------------------------------------------------------------
            // 02. ON SINGLE TAP
            // selected class, keep/clear/remove selection,
            //-----------------------------------------------------------------

            onSingleTap(evt) {
                const multiSelect = evt.shiftKey || evt.ctrlKey || evt.metaKey;
                let {target} = _.simplifyEvent(evt); // this might be problematic

                // Traferse dom upwards to check if target is selectable
                while (!this.selectables.includes(target)) {
                    if (target.parentElement) {
                        target = target.parentElement;
                    } else {
                        return;
                    }
                }



                // if (!this.firstRun) {
                //     this.testVar = target.__vue__.node; // store node temporarily
                //     this.firstRun = true;
                // }

                // console.log(target.__vue__.$el === target); // this works?
                // console.log(this.testVar === target.__vue__.$el);

                // LISTEN UP
                // target that is stored as touched, isn't same __vue__ after drag, storing something else?

                this.touchedElements.push(target);

                // Check if clicked element is already selected
                // const selected = evt.target.classList.contains('selected'); // class active???????
                // const selected = target.classList.contains('selected'); // class active???????

                const selected = this.selectedStore.includes(target);

                // MULTI SELECT PRESSED DOWN
                if (multiSelect) {
                    if (!selected) {
                        // select this one
                        this.keepSelection();
                    } else {
                        // unselect all
                        this.removeFromSelection(target); // evt.target
                    }
                } else {

                    //========================================
                    // USE CASE:
                    // don't unselect all if clicking on a 'selected'
                    // EG. group select then drag
                    //========================================

                    if (!selected) {

                        // unselect all
                        this.clearSelection();

                        // select this one
                        this.keepSelection();
                    }
                }
            },

            //-----------------------------------------------------------------
            // 02. DELAYED TAP MOVE - MAY NOT
            // Check if drag is occuring, if so - update selection area
            //-----------------------------------------------------------------

            delayedTapMove(evt) {
                const {x, y} = _.simplifyEvent(evt);
                // const selectedElements = evt.selectedElements; // no longer necesaary?
                const multiSelect = evt.shiftKey || evt.ctrlKey || evt.metaKey;

                // Check pixel threshold
                if (abs((x + y) - (this.lastX + this.lastY)) >= this.options.startThreshold) {

                    _.off(this.$el, ['mousemove', 'touchmove'], this.delayedTapMove); // this.$el
                    _.on(document, ['mousemove', 'touchmove'], this.onTapMove); // document prevents select sticking on overlaps
                    // _.css(this.areaElement, 'display', 'block');
                    this.dragSelecting = true;

                    // New start position
                    this.updateArea(evt);

                    // Remove class if the user don't pressed the control key or ⌘ key
                    if (!multiSelect) {

                        // Unselect all elements
                        // selectedElements.forEach(s => s.classList.remove('selected'));

                        // Clear previous selection
                        this.clearSelection();
                    }

                    // dispatch onStart here - taken out?

                    // An action is recognized as single-select until
                    // the user performed a mutli-selection
                    this.singleClick = false;
                }
            },

            //-----------------------------------------------------------------
            // 03. ON TAP MOVE - triggered from delayedTapMove
            //-----------------------------------------------------------------

            onTapMove(evt) {
                this.updateArea(evt);
                this.updatedTouchingElements();
                // this.dispatchEvent('onMove', evt); // disptach necessary?
            },

            //-----------------------------------------------------------------
            // 04. ON TAP STOP (USUALLY MOUSE UP)
            // Cancels out drag, switches off listener
            //
            // invokes single tap, hides selection box
            //-----------------------------------------------------------------

            onTapStop(evt, noevent) {

                // Remove event handlers
                _.off(this.$el, ['mousemove', 'touchmove'], this.delayedTapMove);
                _.off(document, ['touchmove', 'mousemove'], this.onTapMove); // needs to match other tapMove
                _.off(document, ['mouseup', 'touchcancel', 'touchend'], this.onTapStop);

                if (!this.singleClick && !noevent) {
                    this.updatedTouchingElements();

                    // this.dispatchEvent('onStop', evt);
                    this.keepSelection(); // above
                }

                // Enable default select event
                _.off(this.$el, 'selectstart', preventDefault);
                // _.css(this.areaElement, 'display', 'none');
                this.dragSelecting = false;
            },

            //-----------------------------------------------------------------
            // UPDATE AREA [LOCKED]
            //-----------------------------------------------------------------

            updateArea(evt) {
                const brect = this.targetBoundary;
                let {x, y} = _.simplifyEvent(evt);

                if (x < brect.left) x = brect.left;
                if (y < brect.top) y = brect.top;
                if (x > brect.left + brect.width) x = brect.left + brect.width;
                if (y > brect.top + brect.height) y = brect.top + brect.height;

                const x3 = min(this.lastX, x);
                const y3 = min(this.lastY, y);
                const x4 = max(this.lastX, x);
                const y4 = max(this.lastY, y);

                this.selectionAreaStyle = {
                    top: y3 + 'px',
                    left: x3 + 'px',
                    width: x4 - x3 + 'px',
                    height: y4 - y3 + 'px'
                };
            },

            //-----------------------------------------------------------------
            // UPDATED TOUCHING ELEMENTS [LOCKED]
            //-----------------------------------------------------------------

            updatedTouchingElements() {
                const touched = [];
                const changed = {added: [], removed: []};

                // Itreate over the selectable elements
                for (let i = 0, n = this.selectables.length; i < n; i++) {
                    const node = this.selectables[i];
                    const file = this.selectables[i].childNodes[0]; // LV: trigger on file not the boundary

                    // Check if area intersects element
                    // if (_.intersects(this.areaElement, node, this.options.mode)) {
                    if (_.intersects(this.areaElement, file, this.options.mode)) {

                        // Fire filter event
                        if (this.dispatchFilterEvent('selectionFilter', node) !== false) {

                            // Check if the element wasn't present in the last selection.
                            if (!this.touchedElements.includes(node)) {
                                changed.added.push(node);
                            }

                            touched.push(node);
                        }
                    }
                }

                // Check which elements where removed since last selection
                changed.removed = this.touchedElements.filter(el => !touched.includes(el));

                // Save
                this.touchedElements = touched;
                this.changedElements = changed;
            },

            //-----------------------------------------------------------------
            // DISPATCH FILTER EVENTS
            //-----------------------------------------------------------------

            dispatchFilterEvent(eventName, element) {
                const event = this.options[eventName];

                // Validate function
                if (typeof event === 'function') {
                    return event.call(this, {selection: this, eventName, element}); // selection this might be problematic
                }
            },

            //-----------------------------------------------------------------
            // DISPATCH EVENT
            //-----------------------------------------------------------------

            dispatchEvent(eventName, originalEvent, additional) {
                const event = this.options[eventName];

                // Validate function
                if (typeof event === 'function') {
                    return event.call(this, {
                        selection: this,
                        areaElement: this.areaElement,
                        selectedElements: this.touchedElements.concat(this.selectedStore),
                        changedElements: this.changedElements,
                        eventName,
                        originalEvent,
                        ...additional
                    });
                }
            },

            //-----------------------------------------------------------------
            // CLICK OUTSIDE
            // elements are considered 'inactive' once clicked away from.
            // inactive is just a visual thing, they're still selected
            //-----------------------------------------------------------------

            clickOutside(evt) {
                const multiSelect = evt.shiftKey || evt.ctrlKey || evt.metaKey; // ctl or ⌘ key down
                if (!multiSelect) {
                    this.inactiveElements = this.selectedStore;
                    this.clearSelection(); // work?
                    this.touchedElements = []; // does this work???
                    // console.log('>> Clicked outside <<'); TODO: is this important? I think it is
                    // console.log(this.$el);
                }
            },

            //-----------------------------------------------------------------
            // KEEP SELECTION
            // Saves the current selection for the next selecion.
            // Allows multiple selections.
            //-----------------------------------------------------------------

            keepSelection() {
                const keep = this.touchedElements.filter(x => !this.selectedStore.includes(x));
                this.selectedStore = keep.concat(this.selectedStore);
            },

            //-----------------------------------------------------------------
            // CLEAR SELECTION | INACTIVE
            // Clear the elements which where saved by 'keepSelection()'.
            //-----------------------------------------------------------------

            clearSelection() {
                this.selectedStore = [];
            },

            clearInactive() {
                this.inactiveElements = [];
            },

            //-----------------------------------------------------------------
            // REMOVE FROM SELECTION
            // Removes an particular element from the selection.
            //-----------------------------------------------------------------

            removeFromSelection(el) {
                _.removeElement(this.selectedStore, el);
                _.removeElement(this.touchedElements, el);
            },

            //-----------------------------------------------------------------
            // GET SELECTION
            // @returns {Array} Selected elements
            //----------------------------------------------------------------

            // getSelection() {
            //     return this.selectedStore;
            //     //
            // },

            //-----------------------------------------------------------------
            // CANCEL
            // Cancel the current selection process.
            // @param  {boolean} true to fire the onStop listener after cancel.
            //-----------------------------------------------------------------

            cancel(keepEvent) {
                this.onTapStop(null, !keepEvent);
            },

            //-----------------------------------------------------------------
            // GET OPTION
            // Set or get an option.
            // @param   {string} name
            // @param   {*}      value
            // @return  {*}      the new value
            //-----------------------------------------------------------------

            // option(name, value) {
            //     const options = this.options;
            //     return value == null ? options[name] : (options[name] = value);
            // },

            //-----------------------------------------------------------------
            // DISABLE
            // Disable the selection functionality.
            //-----------------------------------------------------------------

            disable() {
                this.bindStartEvents('off');
            },

            //-----------------------------------------------------------------
            // DESTROY
            // Unbinds all events and removes the area-element
            //-----------------------------------------------------------------

            destroy() {
                this.disable();
                //this.$el.body.removeChild(this.areaElement);
            },
        }
    }
</script>

<style lang="scss" scoped>

    .kleptos-overflow {
        // background: orange;
        // overflow: hidden; // this controls scrollbars
        // user-select: none;
    }

    // create visual gutter container for the icons
    .kleptos-icons {
        position: relative; // [LOCKED]
        top: rem-calc(10); // [LOCKED]
        left: rem-calc(10); // [LOCKED]
        width: calc(100% - #{rem-calc(10)}); // [LOCKED]
        width: calc(100% - #{rem-calc(10)}); // [LOCKED]
    }

    .selection-area {
        position: fixed; // [LOCKED]
        top: 0; // [LOCKED]
        left: 0; // [LOCKED]
        background: rgba(black, 0.1); // [LOCKED]
        border: 1px solid rgba(black, 0.15); // [LOCKED]
        // z-index: 99;
    }
</style>